export const TipConfigurationScope = {
    Brand: 0,
    LocationGroup: 1,
    Location: 2,
} as const;

export type TipConfigurationScope = (typeof TipConfigurationScope)[keyof typeof TipConfigurationScope];

export const TipCalculationBasis = {
    Subtotal: 0,
    Total: 1,
} as const;

export type TipCalculationBasis = (typeof TipCalculationBasis)[keyof typeof TipCalculationBasis];

export interface TipConfiguration {
    id?: string;
    brandId: string;
    scopeType: TipConfigurationScope;
    scopeId: string;
    calculationBasis: TipCalculationBasis;
    tipAmount1: number;
    tipAmount2: number;
    tipAmount3: number;
    defaultTipAmount: number;
    guestCountMinimumTip: number;
    minimumTipAmount: number;

    /**
     * Whether this scope takes tips at all.
     *
     * Null means INHERIT from the scope above, and is not the same as false. Every other field here overrides
     * as a set — a location with its own row replaces the brand's amounts wholesale — but this one cascades
     * scope by scope, so a location can keep its own presets without restating the brand's policy.
     *
     * A brand has nothing above it, so null and true mean the same thing there.
     */
    tipsEnabled?: boolean | null;
}
